import React from 'react'
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';

const AutofacturacionTicketTrackingTwo = (props) => {
  const { tracking } = props.data;

  const renderItemTracking = (index, item) => {

    const { receptor = {} } = item.debug;
    const hasUuid = !!item?.debug?.uuid;
    const hasReceptor = (!!receptor?.Rfc || !!receptor?.Nombre);

    return (
      <Row>
        <Col>
          <div className="border-bottom p-2">
            <span className="text-muted">{moment(item.created_at).format('DD/MM/YYYY HH:mm') + ' '}</span>
            <br />{ item.status_reason }

            { hasUuid && <strong>{ '. Cfdi:' } { item.debug.uuid }</strong> }

            { hasReceptor &&
              <>
                {'. Receptor: '}
                { receptor?.Rfc } { receptor?.Nombre || '' }
              </>
            }
          </div>
        </Col>
      </Row>
    )
  }

  return (
    tracking.map((item, index) => {
      return (
        <div key={item.id}>
          { renderItemTracking(index, item) }
        </div>
      )
    })
  )
}

export default AutofacturacionTicketTrackingTwo;